export const environment = {
  production: false,
  scopeUri: 'api://b698ae56-7309-477b-abcc-fc8be4f07a18/Read',
  gatewayHost : 'https://nutritional-api-stg.publix.io/api/v1',
  tenantId: '623cac68-b5d0-45f1-9109-3122c3974cc9',
  ClienId: 'dd56ac97-afab-43d3-b44d-8a298361f9fc',  
  apiVersion:'v1'  
};